import axios from "axios";
import {UserInfo} from "../Types/user";

export function fetchUserInfo(): Promise<UserInfo> {
    return axios.get("/api/user")
        .then(res => res.data)
}
